import { render, staticRenderFns } from "./CustomPropertySummary.vue?vue&type=template&id=ab3e846e&"
import script from "./CustomPropertySummary.vue?vue&type=script&lang=ts&"
export * from "./CustomPropertySummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports